
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33904',
  depVersions: {
  "documents-public-ui": "static-1.33904",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33909",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1898",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5364",
  "hs-test-utils": "static-1.7778",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11194",
  "I18n": "static-7.1562",
  "jasmine-immutable": "static-1.2791",
  "jasmine-runner": "static-1.6245",
  "lodash": "static-1.3",
  "quartz": "static-1.6689",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16414",
  "reporting-data": "static-1.66400",
  "reporting-testing-lib": "static-1.8333",
  "reporting-visualizations": "static-1.58476",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4538",
  "webpack-env": "static-1.54",
  "atom": "static-1.4843",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2258",
  "classnames": "static-2.10",
  "cssUtils": "static-1.725",
  "customer-data-filters-ui": "static-1.38787",
  "customer-data-objects": "static-1.7416",
  "customer-data-property-utils": "static-1.7844",
  "data-fetching-client": "static-1.9450",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4302",
  "flux-actions": "static-1.304",
  "FormsCommonComponents": "static-1.85216",
  "FormUrlGenerator": "static-2.4503",
  "foundations-components": "static-1.7471",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11502",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6935",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3632",
  "property-translator": "static-1.5186",
  "quartz-config": "static-1.467",
  "quartz-core": "static-1.5908",
  "quick-fetch": "static-1.3708",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5148",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7933",
  "reference-resolvers-lite": "static-1.7863",
  "report-customization-components": "static-1.12437",
  "reporting-enablement": "static-1.21978",
  "reporting-reports": "static-1.66078",
  "reporting-snowflake": "static-1.55018",
  "reporting-ui-components": "static-2.63671",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4405",
  "sales-content-partitioning": "static-1.8708",
  "SalesContentIndexUI": "static-3.8861",
  "sanitize": "static-1.4247",
  "sanitize-text": "static-1.7913",
  "self-service-api": "static-1.10009",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1527",
  "signup-constants": "static-1.18335",
  "signup-ui-lego-core": "static-1.20345",
  "signup-ui-url-generator": "static-2.7838",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4544",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10767",
  "ui-addon-i18n": "static-1.10905",
  "ui-addon-react-router-dom": "static-1.9321",
  "ui-addon-upgrades": "static-9.17611",
  "ui-asset-management-lib": "static-1.10672",
  "ui-images": "static-2.1085",
  "UIComponents": "static-3.8141",
  "usage-tracker": "static-1.7105",
  "usage-tracker-container": "static-1.7095",
  "usage-tracker-core": "static-1.6955",
  "usage-tracker-public": "static-1.6916",
  "viral-links-lib": "static-1.6803",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3203",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2966",
  "quartz-webpack": "static-1.2913",
  "ai-components-ui-library": "static-1.8275",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4606",
  "foundations-theming": "static-1.4182",
  "quartz-auth": "static-1.364",
  "usage-tracker-session-replay": "static-1.4791",
  "foundations-theming-base": "static-1.3167",
  "HeadJS": "static-2.704",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2889",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4102",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7697",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3480",
  "reporting-client-types": "static-1.2379",
  "hs-story-utils": "static-1.9201",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9412",
  "hubspotter-http": "static-1.4452",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7022",
  "crm-message-bus": "static-1.42271",
  "customer-data-filters-ui-msw-helpers": "static-1.21221",
  "customer-data-objects-ui-components": "static-1.12777",
  "customer-data-reference-ui-components": "static-1.12914",
  "customer-data-ui-utilities": "static-1.9597",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6548",
  "framework-data-schema-resolvers": "static-1.6643",
  "inbound-db-properties-service-client": "static-1.3650",
  "multi-account-reference-resolvers": "static-1.742",
  "onboarding-tours": "static-1.16219",
  "reporting-datasets-permissions-lib": "static-1.12975",
  "ui-addon-teams": "static-1.21203",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67546",
  "customer-data-properties": "static-1.50713",
  "forms-ai-lib": "static-1.3973",
  "forms-utils-lib": "static-1.12119",
  "foundations-components-test-utils": "static-1.4954",
  "react-dnd-compat": "static-1.4395",
  "react-tinymce": "static-1.54547",
  "tinymce-config": "static-2.53673",
  "ui-gdpr-components": "static-1.10120",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3740",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1120",
  "ui-fonts": "static-1.456",
  "dispatcher": "static-1.131",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.787",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.354",
  "quartz-i18n": "static-1.364",
  "quartz-routing": "static-1.119",
  "quartz-test": "static-1.364",
  "batch-promise": "static-1.1323",
  "external-options-client-types": "static-1.3959",
  "react-colorpicker": "static-2.9984",
  "copilot-toolkit": "static-1.10454",
  "data-quality-ui-library": "static-1.12258",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40589",
  "reporting-insights-lib": "static-1.1080",
  "reporting-plugins": "static-1.9947",
  "ui-addon-draggable-compat": "static-2.4026",
  "ui-addon-opt": "static-4.8158",
  "ui-shepherd-react": "static-3.9917",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24647",
  "hubspot-apollo-client": "static-1.4652",
  "sales-templates-service-types-lib": "static-1.3969",
  "ui-business-units-lib": "static-1.8797",
  "merchandise-lib": "static-1.258",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5446",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3879",
  "upgrade-management-service-types": "static-1.4281",
  "timezone-utils": "static-2.5017",
  "bender-build-tools": "static-1.2912",
  "chatspot-core": "static-1.20200",
  "chirp-fetch": "static-1.1657",
  "bend-plugin-foundations-theming": "static-1.2665",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9410",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3599",
  "crm-pipelines-api-client-types": "static-1.3939",
  "multi-currency-client-types": "static-1.3493",
  "getting-started-shared-tasks": "static-1.17803",
  "growth-data-modal": "static-1.5124",
  "growth-onboarding-confetti": "static-1.2843",
  "growth-onboarding-next-action-utils": "static-1.1268",
  "navigation-components": "static-1.17181",
  "onboarding-tours-client": "static-1.4433",
  "onboarding-tours-utils": "static-1.285",
  "ui-shepherd-tracker": "static-1.7298",
  "ui-universal-auth": "static-1.8653",
  "user-context": "static-1.4867",
  "cms-field-types": "static-1.4578",
  "content-icons-ui": "static-1.2146",
  "integrations-lib": "static-1.15329",
  "calling-global-api": "static-1.63560",
  "calling-internal-common": "static-1.31066",
  "calling-lifecycle-internal": "static-1.64942",
  "calling-lifecycle-messages": "static-1.57236",
  "commerce-products-lib": "static-1.8774",
  "crm-links": "static-1.6028",
  "file-manager-components": "static-1.22809",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.446",
  "inbounddb-objects-service-types": "static-1.4025",
  "meetings-icalendar-utils-lib": "static-1.406",
  "object-builder-ui-client": "static-1.47877",
  "pipeline-validation-client-types": "static-1.3761",
  "property-value-citations": "static-1.1327",
  "pulse": "static-1.278",
  "smart-property-lib": "static-1.5776",
  "tiered-pricing": "static-1.787",
  "ui-addon-iframeable": "static-1.8814",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19427",
  "tinymce-themes": "static-1.55643",
  "data-token-picker": "static-1.15999",
  "hub-http-contrib": "static-1.2817",
  "interframe": "static-3.4564",
  "tinymce-data": "static-1.39758",
  "tinymce-plugins": "static-1.56787",
  "ui-addon-sales-email": "static-1.4986",
  "magpie-lib": "static-1.5367",
  "magpie-types": "static-1.4827",
  "simple-logging-lib": "static-1.2823",
  "content-assistance-lib": "static-1.7410",
  "dashboard-lib": "static-1.80519",
  "ExportDialog": "static-6.10161",
  "hubspot-prosemirror": "static-1.17530",
  "hubspot-prosemirror-plugins": "static-1.17522",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8464",
  "campaign-roi-lib": "static-1.8185",
  "feedback-loader": "static-1.28803",
  "onboarding-scopes": "static-1.6236",
  "apollo-link-hub-http": "static-2.4421",
  "hubspot-apollo-cache": "static-1.111",
  "growth-monetization-service-types": "static-1.4297",
  "nav-client-types": "static-1.2129",
  "purchase-motions-api": "static-1.5449",
  "trials-service-types": "static-1.3698",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.499",
  "unified-auth-core-lib": "static-1.448",
  "getting-started-shared-tasks-store": "static-1.16921",
  "integrations-error-boundary-lib": "static-1.12744",
  "integrations-tracking-lib": "static-1.5357",
  "native-integrations-shared-strings": "static-1.7561",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10145",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31072",
  "shared-worker-versioning": "static-1.10809",
  "calling-usage-tracker": "static-1.6311",
  "voice-sms-access-library": "static-1.162",
  "customer-data-tracking": "static-1.6654",
  "products-iframe-lib": "static-1.7241",
  "products-ui-components-shared-msw-handlers": "static-1.9794",
  "location-customization-utils-lib": "static-1.8468",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3927",
  "video-components-external": "static-1.10486",
  "video-data-lib": "static-1.34144",
  "directed-graph": "static-1.710",
  "event-emitter": "static-1.720",
  "breeze-intelligence-kit": "static-1.5282",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9495",
  "fsm": "static-1.3504",
  "policy-lib": "static-1.6554",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9558",
  "navigation-messaging": "static-1.6508",
  "FileManagerLib": "static-1.38449",
  "NamespacedHubStyle": "static-2.8871",
  "FileManagerCore": "static-1.38308",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.11983",
  "layout-dnd-utils": "static-1.10958",
  "react-codemirror": "static-1.10399",
  "ui-addon-emoji-picker": "static-1.9661",
  "ui-brand-identity-lib": "static-1.13737",
  "ui-addon-video-player": "static-1.8469",
  "ui-coaching-tips": "static-1.27872",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8342",
  "payment-link-components": "static-1.22864",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2979",
  "universal-page-editor-lib": "static-1.2769",
  "calling-orchestration-schema": "static-1.34939",
  "sales-views-client-types": "static-1.4065",
  "crm-record-cards-service-types": "static-1.3427",
  "content-media-composition-data-lib": "static-1.11351",
  "content-media-compositions": "static-2.15358",
  "media-bridge-lib": "static-1.18521",
  "trellis-story-utils": "static-1.4296",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5574",
  "FileManagerImages": "static-1.35960",
  "video-components": "static-1.12489",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4307",
  "video-embed": "static-1.34978",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67621",
  "layout-data-lib": "static-1.9283",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6358",
  "commerce-tours-lib": "static-1.5676",
  "growth-onboarding-reliability": "static-1.4861",
  "sales-checkout-service-client": "static-1.3451",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21265",
  "sales-email-signature-service-client": "static-1.3618",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21265",
  "outpost": "static-1.3979",
  "advanced-menus-core": "static-1.14776",
  "advanced-menus-lib": "static-1.11756",
  "ui-memberships-settings-lib": "static-1.33356",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14775",
  "simple-menus-lib": "static-1.16292"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33904",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33909",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1898",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5364",
  "hs-test-utils": "/hs-test-utils/static-1.7778",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11194",
  "I18n": "/I18n/static-7.1562",
  "jasmine-immutable": "/jasmine-immutable/static-1.2791",
  "jasmine-runner": "/jasmine-runner/static-1.6245",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6689",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16414",
  "reporting-data": "/reporting-data/static-1.66400",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8333",
  "reporting-visualizations": "/reporting-visualizations/static-1.58476",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4538",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4843",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2258",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.725",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38787",
  "customer-data-objects": "/customer-data-objects/static-1.7416",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7844",
  "data-fetching-client": "/data-fetching-client/static-1.9450",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4302",
  "flux-actions": "/flux-actions/static-1.304",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85216",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4503",
  "foundations-components": "/foundations-components/static-1.7471",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11502",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6935",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3632",
  "property-translator": "/property-translator/static-1.5186",
  "quartz-config": "/quartz-config/static-1.467",
  "quartz-core": "/quartz-core/static-1.5908",
  "quick-fetch": "/quick-fetch/static-1.3708",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5148",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7933",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7863",
  "report-customization-components": "/report-customization-components/static-1.12437",
  "reporting-enablement": "/reporting-enablement/static-1.21978",
  "reporting-reports": "/reporting-reports/static-1.66078",
  "reporting-snowflake": "/reporting-snowflake/static-1.55018",
  "reporting-ui-components": "/reporting-ui-components/static-2.63671",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4405",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8708",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8861",
  "sanitize": "/sanitize/static-1.4247",
  "sanitize-text": "/sanitize-text/static-1.7913",
  "self-service-api": "/self-service-api/static-1.10009",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1527",
  "signup-constants": "/signup-constants/static-1.18335",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20345",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7838",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4544",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10767",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10905",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9321",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17611",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10672",
  "ui-images": "/ui-images/static-2.1085",
  "UIComponents": "/UIComponents/static-3.8141",
  "usage-tracker": "/usage-tracker/static-1.7105",
  "usage-tracker-container": "/usage-tracker-container/static-1.7095",
  "usage-tracker-core": "/usage-tracker-core/static-1.6955",
  "usage-tracker-public": "/usage-tracker-public/static-1.6916",
  "viral-links-lib": "/viral-links-lib/static-1.6803",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3203",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2966",
  "quartz-webpack": "/quartz-webpack/static-1.2913",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8275",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4606",
  "foundations-theming": "/foundations-theming/static-1.4182",
  "quartz-auth": "/quartz-auth/static-1.364",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4791",
  "foundations-theming-base": "/foundations-theming-base/static-1.3167",
  "HeadJS": "/HeadJS/static-2.704",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2889",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4102",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7697",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3480",
  "reporting-client-types": "/reporting-client-types/static-1.2379",
  "hs-story-utils": "/hs-story-utils/static-1.9201",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9412",
  "hubspotter-http": "/hubspotter-http/static-1.4452",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7022",
  "crm-message-bus": "/crm-message-bus/static-1.42271",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21221",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12777",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12914",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9597",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6548",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6643",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3650",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.742",
  "onboarding-tours": "/onboarding-tours/static-1.16219",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12975",
  "ui-addon-teams": "/ui-addon-teams/static-1.21203",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67546",
  "customer-data-properties": "/customer-data-properties/static-1.50713",
  "forms-ai-lib": "/forms-ai-lib/static-1.3973",
  "forms-utils-lib": "/forms-utils-lib/static-1.12119",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4954",
  "react-dnd-compat": "/react-dnd-compat/static-1.4395",
  "react-tinymce": "/react-tinymce/static-1.54547",
  "tinymce-config": "/tinymce-config/static-2.53673",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10120",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3740",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1120",
  "ui-fonts": "/ui-fonts/static-1.456",
  "dispatcher": "/dispatcher/static-1.131",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.354",
  "quartz-i18n": "/quartz-i18n/static-1.364",
  "quartz-routing": "/quartz-routing/static-1.119",
  "quartz-test": "/quartz-test/static-1.364",
  "batch-promise": "/batch-promise/static-1.1323",
  "external-options-client-types": "/external-options-client-types/static-1.3959",
  "react-colorpicker": "/react-colorpicker/static-2.9984",
  "copilot-toolkit": "/copilot-toolkit/static-1.10454",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12258",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40589",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1080",
  "reporting-plugins": "/reporting-plugins/static-1.9947",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4026",
  "ui-addon-opt": "/ui-addon-opt/static-4.8158",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9917",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24647",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4652",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3969",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8797",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5446",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3879",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4281",
  "timezone-utils": "/timezone-utils/static-2.5017",
  "bender-build-tools": "/bender-build-tools/static-1.2912",
  "chatspot-core": "/chatspot-core/static-1.20200",
  "chirp-fetch": "/chirp-fetch/static-1.1657",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2665",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9410",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3599",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3939",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3493",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17803",
  "growth-data-modal": "/growth-data-modal/static-1.5124",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2843",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1268",
  "navigation-components": "/navigation-components/static-1.17181",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4433",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.285",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7298",
  "ui-universal-auth": "/ui-universal-auth/static-1.8653",
  "user-context": "/user-context/static-1.4867",
  "cms-field-types": "/cms-field-types/static-1.4578",
  "content-icons-ui": "/content-icons-ui/static-1.2146",
  "integrations-lib": "/integrations-lib/static-1.15329",
  "calling-global-api": "/calling-global-api/static-1.63560",
  "calling-internal-common": "/calling-internal-common/static-1.31066",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64942",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57236",
  "commerce-products-lib": "/commerce-products-lib/static-1.8774",
  "crm-links": "/crm-links/static-1.6028",
  "file-manager-components": "/file-manager-components/static-1.22809",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.446",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4025",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.406",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47877",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3761",
  "property-value-citations": "/property-value-citations/static-1.1327",
  "pulse": "/pulse/static-1.278",
  "smart-property-lib": "/smart-property-lib/static-1.5776",
  "tiered-pricing": "/tiered-pricing/static-1.787",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8814",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19427",
  "tinymce-themes": "/tinymce-themes/static-1.55643",
  "data-token-picker": "/data-token-picker/static-1.15999",
  "hub-http-contrib": "/hub-http-contrib/static-1.2817",
  "interframe": "/interframe/static-3.4564",
  "tinymce-data": "/tinymce-data/static-1.39758",
  "tinymce-plugins": "/tinymce-plugins/static-1.56787",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4986",
  "magpie-lib": "/magpie-lib/static-1.5367",
  "magpie-types": "/magpie-types/static-1.4827",
  "simple-logging-lib": "/simple-logging-lib/static-1.2823",
  "content-assistance-lib": "/content-assistance-lib/static-1.7410",
  "dashboard-lib": "/dashboard-lib/static-1.80519",
  "ExportDialog": "/ExportDialog/static-6.10161",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17530",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17522",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8464",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8185",
  "feedback-loader": "/feedback-loader/static-1.28803",
  "onboarding-scopes": "/onboarding-scopes/static-1.6236",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4421",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.111",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4297",
  "nav-client-types": "/nav-client-types/static-1.2129",
  "purchase-motions-api": "/purchase-motions-api/static-1.5449",
  "trials-service-types": "/trials-service-types/static-1.3698",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.499",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.448",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16921",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12744",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5357",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7561",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10145",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31072",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10809",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6311",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.162",
  "customer-data-tracking": "/customer-data-tracking/static-1.6654",
  "products-iframe-lib": "/products-iframe-lib/static-1.7241",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9794",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8468",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3927",
  "video-components-external": "/video-components-external/static-1.10486",
  "video-data-lib": "/video-data-lib/static-1.34144",
  "directed-graph": "/directed-graph/static-1.710",
  "event-emitter": "/event-emitter/static-1.720",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5282",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9495",
  "fsm": "/fsm/static-1.3504",
  "policy-lib": "/policy-lib/static-1.6554",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9558",
  "navigation-messaging": "/navigation-messaging/static-1.6508",
  "FileManagerLib": "/FileManagerLib/static-1.38449",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8871",
  "FileManagerCore": "/FileManagerCore/static-1.38308",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.11983",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10958",
  "react-codemirror": "/react-codemirror/static-1.10399",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9661",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13737",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8469",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27872",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8342",
  "payment-link-components": "/payment-link-components/static-1.22864",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2979",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2769",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34939",
  "sales-views-client-types": "/sales-views-client-types/static-1.4065",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3427",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11351",
  "content-media-compositions": "/content-media-compositions/static-2.15358",
  "media-bridge-lib": "/media-bridge-lib/static-1.18521",
  "trellis-story-utils": "/trellis-story-utils/static-1.4296",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5574",
  "FileManagerImages": "/FileManagerImages/static-1.35960",
  "video-components": "/video-components/static-1.12489",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4307",
  "video-embed": "/video-embed/static-1.34978",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67621",
  "layout-data-lib": "/layout-data-lib/static-1.9283",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6358",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5676",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4861",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3451",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21265",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3618",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "outpost": "/outpost/static-1.3979",
  "advanced-menus-core": "/advanced-menus-core/static-1.14776",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11756",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33356",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14775",
  "simple-menus-lib": "/simple-menus-lib/static-1.16292"
}
};
